import { TFunction } from 'react-i18next';
import { enabledValidation } from 'utils/yup';
import * as yup from 'yup';

export default (t: TFunction): any =>
  yup.object({
    description: yup.string().required(t('schema-CloverPointConfig-form-description-required')),
    deviceAddress: yup.string(),
    isPaired: yup.boolean().required(t('schema-CloverPoint-form-device-is-paired-required')),
    isAutoService: yup.boolean().required(t('schema-CloverPoint-form-device-is-autoservice-required')),
    acceptsCash: yup.boolean().required(t('schema-CloverPoint-form-device-accepts-cash-required')),
    isUsedOnLuxuryBox: enabledValidation(t),
    luxuryBoxId: yup.mixed().when('isUsedOnLuxuryBox', {
      is: true,
      then: yup
        .string()
        .test('luxuryBoxIdRequired', t('schema-CloverPoint-form-luxury-box-required'), (value, context) => {
          console.log(context.parent.isAutoService && !value);
          if (context.parent.isAutoService && !value) {
            return false;
          }
          return true;
        }),
      otherwise: yup.string(),
    }),
  });
